import { useEffect } from "react";
import useLiveOrdersRefetch from "../v2/hooks/useLiveOrdersRefetch";
import useBranchId from "./useBranchId";
import { pusherClient } from "../socket";

const useOrdersSocket = (localBranch?: number, cb?: () => void) => {
  const refetch = useLiveOrdersRefetch();
  const branch = useBranchId();

  useEffect(() => {
    if (branch === -1) return;
    if (branch === undefined) return;

    if (localBranch !== undefined && localBranch === branch) return;
    const data = localBranch ?? branch;
    const branchChannel = "branch-" + data;
    pusherClient.subscribe(branchChannel).bind("newOrder", () => {
      cb ? cb() : refetch();
    });

    return () => {
      pusherClient.unsubscribe(branchChannel);
    };
  }, [branch, localBranch]);
};

export default useOrdersSocket;
